import React, { useEffect, useState } from "react";
import completedImage from "../../assests/images/Completed.png";
import purchaseImage from "../../assests/images/Purchase.png";
import pendingImage from "../../assests/images/Pending.png";
import shippedImage from "../../assests/images/Shipped.png";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Link, useLocation } from "react-router-dom";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import Stack from "@mui/material/Stack";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepContent from "@mui/material/StepContent";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import CachedOutlinedIcon from '@mui/icons-material/CachedOutlined';
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";


const initialColumns = [
  { id: "col1", label: "Vendor ID", isSort: true, sortLabel: "" },
  { id: "col2", label: "Vendor Name", isSort: true, sortLabel: "" },
  { id: "col3", label: "Document Number", isSort: true, sortLabel: "" },
  { id: "col4", label: "Document Date", isSort: true, sortLabel: "" },
  { id: "col5", label: "Posting Date", isSort: true, sortLabel: "" },
  { id: "col6", label: "Reference", isSort: true, sortLabel: "" },
  { id: "col7", label: "Document Type", isSort: true, sortLabel: "" },
  { id: "col8", label: "Amount", isSort: true, sortLabel: "" },
  { id: "col9", label: "Currency", isSort: true, sortLabel: "" },
  { id: "col10", label: "Debit/Credit", isSort: true, sortLabel: "" },
  { id: "col11", label: "Account Assignment", isSort: true, sortLabel: "" },
  { id: "col12", label: "Description", isSort: true, sortLabel: "" },
  { id: "col13", label: "" },
];
const rows = [
  {
    col1: (
      <Link
        className="solutions_block_body"
        style={{ textDecoration: "none" }}
        to="/admin/Vendor-CNDN-Detail"
      >
        100001
      </Link>
    ),
    col2: "ABC Supplies",
    col3: "4500012354",
    col4: "2024-06-01",
    col5: "2024-06-02",
    col6: "CN001",
    col7: "Credit Note",
    col8: "-500",
    col9: "INR",
    col10: "Credit",
    col11: "Cost Center A",
    col12: "Returned Office Supplies",
    col13: <MoreVertIcon />,
  },
  {
    col1: "100002",
    col2: "XYZ Traders",
    col3: "4500012355",
    col4: "2024-06-03",
    col5: "2024-06-04",
    col6: "DN001",
    col7: "Debit Note",
    col8: "1200",
    col9: "INR",
    col10: "Debit",
    col11: "Cost Center B",
    col12: "Additional Raw Material Charges",
    col13: <MoreVertIcon />,
  },
  {
    col1: "100003",
    col2: "LMN Enterprises",
    col3: "4500012356",
    col4: "2024-06-05",
    col5: "2024-06-06",
    col6: "CN002",
    col7: "Credit Note",
    col8: "-300",
    col9: "INR",
    col10: "Credit",
    col11: "Cost Center C",
    col12: "Returned IT Equipment",
    col13: <MoreVertIcon />,
  },
  {
    col1: "100001",
    col2: "ABC Supplies",
    col3: "4500012357",
    col4: "2024-06-07",
    col5: "2024-06-08",
    col6: "DN002",
    col7: "Debit Note",
    col8: "800",
    col9: "INR",
    col10: "Debit",
    col11: "Cost Center A",
    col12: "Extra Stationery Charges",
    col13: <MoreVertIcon />,
  },
  {
    col1: "100002",
    col2: "XYZ Traders",
    col3: "4500012358",
    col4: "2024-06-09",
    col5: "2024-06-10",
    col6: "CN003",
    col7: "Credit Note",
    col8: "-450",
    col9: "INR",
    col10: "Credit",
    col11: "Cost Center B",
    col12: "Cleaning Supplies Return",
    col13: <MoreVertIcon />,
  },
  {
    col1: "100001",
    col2: "LMN Enterprises",
    col3: "4500012359",
    col4: "2024-06-11",
    col5: "2024-06-12",
    col6: "DN003",
    col7: "Debit Note",
    col8: "2500",
    col9: "INR",
    col10: "Debit",
    col11: "Cost Center C",
    col12: "Office Furniture Additional Cost",
    col13: <MoreVertIcon />,
  },
  {
    col1: "100001",
    col2: "LMN Enterprises",
    col3: "4500012359",
    col4: "2024-06-11",
    col5: "2024-06-12",
    col6: "DN003",
    col7: "Debit Note",
    col8: "2500",
    col9: "INR",
    col10: "Debit",
    col11: "Cost Center C",
    col12: "Office Furniture Additional Cost",
    col13: <MoreVertIcon />,
  },
  {
    col1: "100001",
    col2: "LMN Enterprises",
    col3: "4500012359",
    col4: "2024-06-11",
    col5: "2024-06-12",
    col6: "DN003",
    col7: "Debit Note",
    col8: "2500",
    col9: "INR",
    col10: "Debit",
    col11: "Cost Center C",
    col12: "Office Furniture Additional Cost",
    col13: <MoreVertIcon />,
  },

  // Add other rows similarly...
];

const style1 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const steps = [
  {
    label: "PO Creation",
    text: "Created on : 12-02-2024",
    description: `Created At : 10:00`,
    remarks: `Created By : Sanjeev`,
  },
  {
    label: "PO Approval",
    text: "Approved on : 12-02-2024",
    description: `Approved By : Sanjeev`,
  },
  {
    label: "QC Creation : QC0001, QC0002",
    headings: "QC0001",
    text: "Approved on : 12-02-2024",
    remarks: "QC Created At : 10:00",
    description: `Approved By : Sanjeev`,
    headings2: "QC0002",
    remarks2: "QC Created on : 12-02-2024",
    description2: "QC Created At : 10:00",
    text2: "QC Created By : Sanjeev"
  },
  {
    label: "LR Creation : LR0001, LR0002",
    headings: "LR0001",
    text: "LR Created on : 12-02-2024",
    remarks: "LR Created At : 10:00",
    description: `LR Created By : Sanjeev`,
    headings2: "LR0002",
    remarks2: "LR Created on : 12-02-2024",
    description2: "LR Created At : 10:00",
    text2: "LR Created By : Sanjeev"
  },
  {
    label: "QC Creation : QC0003, QC0004",
    headings: "QC0003",
    text: "QC Created on : 12-02-2024",
    remarks: "QC Created At : 10:00",
    description: `QC Created By : Sanjeev`,
    headings2: "QC0004",
    remarks2: "QC Created on : 12-02-2024",
    description2: "QC Created At : 10:00",
    text2: "QC Created By : Sanjeev"
  },
  {
    label: "LR Delivered : LR0001, LR0002",
    headings: "LR0001",
    text: "LR Created on : 12-02-2024",
    remarks: "LR Created At : 10:00",
    description: `LR Created By : Sanjeev`,
    headings2: "LR0004",
    remarks2: "LR Created on : 12-02-2024",
    description2: "LR Created At : 10:00",
    text2: "LR Created By : Sanjeev"
  },
  {
    label: "Gate Creation : GE0001, GE0002",
    headings: "GE0001",
    text: "GE Created on : 12-02-2024",
    remarks: "GE Created At : 10:00",
    description: `GE Created By : Sanjeev`,
    headings2: "GE0002",
    remarks2: "GE Created on : 12-02-2024",
    description2: "GE Created At : 10:00",
    text2: "GE Created By : Sanjeev"
  },
  {
    label: "GRN Creation : GRN0001, GRN0002",
    headings: "GRN0001",
    text: "GRN Created on : 12-02-2024",
    remarks: "GRN Created At : 10:00",
    description: `GRN Created By : Sanjeev`,
    headings2: "GRN0002",
    remarks2: "GRN Created on : 12-02-2024",
    description2: "GRN Created At : 10:00",
    text2: "GRN Created By : Sanjeev"
  },

  // Add more steps if needed...
];

function CndnListing() {
  const qcListing = {
    currentPage: 1,
    totalPages: 20,
  }
  const [inputPage, setInputPage] = useState(qcListing?.currentPage || 1);

  const onPaginationChange = (e, value) => {
    // let requestPayloadInit = _.cloneDeep(requestPayload);
    // requestPayloadInit.pageNumber = value;
    // setRequestPayload(requestPayloadInit); 
  }
  const handleInputChange = (event) => {
    const value = event.target.value;
    if (value === '' || /^[0-9]+$/.test(value)) {
      setInputPage(value);
    }
  };

  const handleInputSubmit = (event) => {
    if (event.key === 'Enter') {
      const page = parseInt(inputPage, 10);
      if (!isNaN(page) && page > 0 && page <= qcListing?.totalPages) {
        onPaginationChange(event, page);
      } else {
        setInputPage(qcListing?.currentPage);
      }
    }
  };
  const [opencreateentry, setOpenCreateEntry] = useState(false);
  const [columns, setColumns] = useState(initialColumns);
  const onSortChange = (index, sortBy, sortOrder) => {
    let newSortLael = (sortOrder == "asc") ? "desc" : "asc";
  }
  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    const reorderedColumns = Array.from(columns);
    const [removed] = reorderedColumns.splice(result.source.index, 1);
    reorderedColumns.splice(result.destination.index, 0, removed);

    setColumns(reorderedColumns);
  };
  const reducer = (state, action) => {
    switch (action.type) {
      case "TOGGLE_DRAWER":
        return { ...state, open: action.newOpen };
      default:
        throw new Error(`Unknown action: ${action.type}`);
    }
  };
  const [state, dispatch] = React.useReducer(reducer, { open: false });

  const toggleDrawer = (newOpen) => () => {
    dispatch({ type: "TOGGLE_DRAWER", newOpen });
  };
  const DrawerList = (
    <Box
      sx={{
        width: 350,
        zIndex: 1300,
      }}
      role="presentation"
    >
      <List>
        <div className="row_order_sidebar_bdpt_po_div">
          <div className="track_order_form_bdpt_sm">
            <h6 className="main_heading_trackordertexr">Track Order</h6>
            <div>
              <CachedOutlinedIcon />
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={toggleDrawer(false)}
              ></button>
            </div>
          </div>
          <div className="track_order_row_bpdt_react">
            <div>
              <h6 className="username_bpdt_div_react">PO Number</h6>
              <p className="username_bpdt_div_react_row1">00234</p>
            </div>
            <div>
              <h6 className="username_bpdt_div_react">Status</h6>
              <p class="date_solutions_status_row">Pending</p>
            </div>
          </div>
          <div className="track_order_row_bpdt_react">
            <div>
              <h6 className="username_bpdt_div_react">Creation Date</h6>
              <p className="username_bpdt_div_react_row1">12-02-2024</p>
            </div>
            <div>
              <h6 className="username_bpdt_div_react">Target Date</h6>
              <p className="username_bpdt_div_react_row1">16-03-2024</p>
            </div>
            <div>
              <h6 className="username_bpdt_div_react">Delivery Date</h6>
              <p className="username_bpdt_div_react_row1">19-03-2024</p>
            </div>
          </div>
        </div>
      </List>
      <Divider />
      <List>
        <div>
          <Box className="po_detail_bfdt_row_div_sidebar1 trackorder_section">
            <Stepper orientation="vertical">
              {steps.map((step, index) => (
                <Step style={{ display: "-webkit-box" }} key={index} expanded>
                  {index === 0 || index === 1 ? (
                    <div>
                      {" "}
                      <StepLabel>{step.label}</StepLabel>
                      <StepContent>
                        {step.headings && (
                          <Typography sx={{ mt: 1 }}>
                            {step.headings}
                          </Typography>
                        )}
                        {step.text && (
                          <Typography sx={{ mt: 1 }}>{step.text}</Typography>
                        )}
                        {step.remarks && (
                          <Typography sx={{ mt: 1 }}>{step.remarks}</Typography>
                        )}
                        <Typography>{step.description}</Typography>
                      </StepContent>
                      <StepContent>
                        {step.headings2 && (
                          <Typography
                            className="stepcontent_block_body"
                            sx={{ mt: 1 }}
                          >
                            {step.headings2}
                          </Typography>
                        )}
                        {step.remarks2 && (
                          <Typography sx={{ mt: 1 }}>
                            {step.remarks2}
                          </Typography>
                        )}
                        {step.description2 && (
                          <Typography sx={{ mt: 1 }}>
                            {step.description2}
                          </Typography>
                        )}
                        {step.text2 && (
                          <Typography sx={{ mt: 1 }}>{step.text2}</Typography>
                        )}
                      </StepContent>{" "}
                    </div>
                  ) : (
                    <div>
                      <StepLabel>
                        <Accordion>
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                          >
                            {step.label}
                          </AccordionSummary>

                          <AccordionDetails>
                            {step.headings && (
                              <Typography sx={{ mt: 1 }}>
                                {step.headings}
                              </Typography>
                            )}
                            {step.text && (
                              <Typography sx={{ mt: 1 }}>
                                {step.text}
                              </Typography>
                            )}
                            {step.remarks && (
                              <Typography sx={{ mt: 1 }}>
                                {step.remarks}
                              </Typography>
                            )}
                            <Typography>{step.description}</Typography>

                            {step.headings2 && (
                              <Typography
                                className="stepcontent_block_body"
                                sx={{ mt: 1 }}
                              >
                                {step.headings2}
                              </Typography>
                            )}
                            {step.remarks2 && (
                              <Typography sx={{ mt: 1 }}>
                                {step.remarks2}
                              </Typography>
                            )}
                            {step.description2 && (
                              <Typography sx={{ mt: 1 }}>
                                {step.description2}
                              </Typography>
                            )}
                            {step.text2 && (
                              <Typography sx={{ mt: 1 }}>
                                {step.text2}
                              </Typography>
                            )}
                          </AccordionDetails>
                        </Accordion>
                      </StepLabel>
                    </div>
                  )}
                </Step>
              ))}
            </Stepper>
          </Box>
        </div>
      </List>
    </Box>
  );
  return (
    <>
      <div className="login-forms">
        <div className="text-centers row_purchase_invoice_dragdropcontext_apps_body">
          <div>
            <div className="search_filter_outerse ms-auto">
              <div className="search_mains">
                <h5>CN/DN Listing</h5>
              </div>
              <div className="vendor_listing_lr_block_body">
                {/* <button
                // onClick={() => {
                //   setOpenCreateEntry(true);
                // }}
                className="gate_btn_lr_creations"
              >
                Create CN/DN
              </button> */}
              </div>
            </div>
            <div className="account_ledger_listing_row1">
              <div className="accout_ledger_listing_block1">
                <div className="listing_project_block_7">
                  <div className="lets_detail_orderlisting">
                    <label className="lets_completed_orderlisting">
                      Total CN/DN
                    </label>
                    <p className="block_detail_listing">
                      <b>345</b>
                    </p>
                  </div>
                <img className="purchase_images_letscom"
                    src={purchaseImage}
                    alt=""
                  />
                </div>
              </div>
              <div className="accout_ledger_listing_block1">
                <div className="listing_project_block_7">
                  <div className="lets_detail_orderlisting">
                    <label className="lets_completed_orderlisting">
                      Total Pending CN/DN
                    </label>
                    <p className="block_detail_listing">
                      <b>145</b>
                    </p>
                  </div>
          <img className="purchase_images_letscom"
                    src={pendingImage}
                    alt=""
                  />
                </div>
              </div>
              <div className="accout_ledger_listing_block1">
                <div className="listing_project_block_7">
                  <div className="lets_detail_orderlisting">
                    <label className="lets_completed_orderlisting">
                      Total Complete CN/DN
                    </label>
                    <p className="block_detail_listing">
                      <b>34</b>
                    </p>
                  </div>
                  <img className="purchase_images_letscom"                 
                    src={shippedImage}
                    alt=""
                  />
                </div>
              </div>          
              <div className="accout_ledger_listing_block1">
                <div className="listing_project_block_7">
                  <div className="lets_detail_orderlisting">
                    <label className="lets_completed_orderlisting">
                      Total CN/DN In Progress
                    </label>
                    <p className="block_detail_listing">
                      <b>175</b>
                    </p>
                  </div>
                   <img className="purchase_images_letscom"
                    src={completedImage}
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div className="search_filter_outers ms-auto">
              <div className="search_main">
                <div id="custom-search-input">
                  <div className="input-group col-md-12">
                    <input
                      type="text"
                      className="form-control input-lg"
                      placeholder="Search here"
                      fdprocessedid="8achb"
                    />
                    <span className="input-group-btn">
                      <button
                        className="btn btn-info btn-lg"
                        type="button"
                        fdprocessedid="trsp06"
                      >
                        <span className="glyphicon glyphicon-search">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-search"
                            viewBox="0 0 16 16"
                          >
                            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"></path>
                          </svg>
                        </span>
                      </button>
                    </span>
                  </div>
                </div>
              </div>
              <div className="bpdt_po_order_react">
                <div>
                  <button className="btn btn-outline-secondary"
                    onClick={toggleDrawer(true)}
                  >
                    Track Order
                  </button>

                  <Drawer
                    anchor="right"
                    open={state.open}
                    onClose={toggleDrawer(false)}
                    style={{ zIndex: 99999 }}
                  >
                    {DrawerList}
                  </Drawer>
                </div>
                <div>
                  <button className="row_filterrbtnvendor_box">
                    <span>
                      <FilterAltOutlinedIcon />
                    </span>
                    Filter
                  </button>
                </div>
              </div>
            </div>
          </div>
          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="droppable" direction="horizontal">
              {(provided) => (
                <div style={{ width: "100%", overflow: "hidden" }}
                  className="listing_main listing_main_dragdropcontext_body"
                  // style={{ height: "400px" }}
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                >
                  <table className="dragdropcontext_ondragend_block_row">
                    <thead style={{ position: "sticky", top: "0", zIndex: 1 }}>
                      <tr>
                        <th className="vendor_tabels">
                          <input type="checkbox" />
                        </th>
                        {columns.map((column, index) => (
                          <Draggable
                            key={column.id}
                            draggableId={column.id}
                            index={index}
                          >
                            {(provided) => (
                              <th
                                className="vendor_tabels"
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                              >
                                {column.label}
                                {column.isSort && (
                                  <span
                                    onClick={() =>
                                      onSortChange(index, column.id, column.sortLabel)
                                    }
                                    className="table-sort-ico"
                                  >
                                  </span>
                                )}
                              </th>
                            )}
                          </Draggable>
                        ))}
                      </tr>
                    </thead>
                    <tbody style={{ overflowY: "scroll", width: "200px" }}>
                      {rows.map((row, rowIndex) => (
                        <tr key={rowIndex} className="maine_tr_vendor">
                          <td>
                            <input type="checkbox" />
                          </td>
                          {columns.map((column, index) => (
                            <td
                              key={index}
                              className={
                                index === 0 ? "block_solar" : ""
                              }
                            >
                              {row[column.id]}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
          <div className="lets_pagination_package_listing_react">
            <div className="pagination_select_react_packagelr_detail">
              <select className="form-select packagelrlisting from-hs">
                <option selected="1">10</option>
                <option value="2">15</option>
                <option value="3">20</option>
                <option value="4">25</option>
                <option value="5">50</option>
              </select>
              <span className="react_text_showing">
                &nbsp;Showing rows 1 to&nbsp;10 of&nbsp;10
              </span>
            </div>
            <Stack spacing={2}>
              <Pagination
                count={qcListing?.totalPages}
                page={qcListing?.currentPage}
                onChange={(event, page) => {
                  setInputPage(page);
                  onPaginationChange(event, page);
                }}
                renderItem={(item) => {
                  if (item.page === qcListing?.currentPage) {
                    return (
                      <input
                        className="form-control form-hasw"
                        type="text"
                        value={inputPage}
                        onChange={handleInputChange}
                        onKeyDown={handleInputSubmit}
                        style={{ width: "50px", marginLeft: "5px", marginRight: "5px", textAlign: "center" }}
                      />
                    );
                  }
                  return (
                    <PaginationItem
                      className="pagination_react_listings"
                      slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                      {...item}
                    />
                  );
                }}
              // count={5}
              // renderItem={(item) => (
              //   <PaginationItem
              //     className="pagination_react_listings"
              //     slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
              //     {...item}
              //   />
              // )}
              />
            </Stack>
          </div>
          {/* Create GRN Modal */}
          <Modal
            open={opencreateentry}
            onClose={() => setOpenCreateEntry(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenCreateEntry(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <p class="project_manager_bidding">
                  Are you sure you want to "<b>Create GRN</b>"
                  <br />
                </p>
                <div className="all_btn_modal_listing">
                  <button
                    href="onboarding_status.html"
                    className="view_progresse"
                    onClick={() => {
                      setOpenCreateEntry(false);
                    }}
                  >
                    Yes
                  </button>

                  <button
                    href="onboarding_status.html"
                    className="view_lsting"
                    onClick={() => setOpenCreateEntry(false)}
                  >
                    No
                  </button>
                </div>
              </div>
            </Box>
          </Modal>
        </div>
      </div>
    </>
  );
}

export default CndnListing;
